import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDSpChatroomAuthFail implements ICommand
{

	public ErrorCode : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.ErrorCode = ba.readUint16();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint16(this.ErrorCode);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDSpChatroomAuthFail();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'ErrorCode(W)='+this.ErrorCode+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 52001;
	}

	public getCmdName() : string
	{
		return 'SpChatroomAuthFail';
	}

}
